import React from 'react';

import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { DocsBitText, DocsIllustration, DocsTable, DocsTd, DocsTr } from 'apps/auth/components/common/components/DocsList/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import DocsFooter from './DocsFooter';

const UsaDocsList = (props) => {
    const { docsOr, takePhotoOfOne, passport: passportMessage, photoIdCard, driverLicense } = usePageMessages();

    return (
        <DocsList>
            <DocsListItem title={takePhotoOfOne}>
                <DocsTable>
                    <DocsTr>
                        <DocsTd>
                            <DocsIllustration>
                                <img src={`${URL_IMAGES_I}/kyc-passport.svg`} alt="passport" />
                            </DocsIllustration>
                            <DocsBitText>{docsOr}</DocsBitText>
                        </DocsTd>
                        <DocsTd>
                            <DocsIllustration>
                                <img src={`${URL_IMAGES_I}/kyc-id-card.svg`} alt="idcard" />
                            </DocsIllustration>
                        </DocsTd>
                    </DocsTr>
                    <DocsTr>
                        <DocsTd>
                            <Text variant={'paragraph'}>{passportMessage}</Text>
                        </DocsTd>
                        <DocsTd>
                            <Text variant={'paragraph'} indent={'16px'}>
                                {photoIdCard}
                            </Text>
                            <Text variant={'paragraph'}>{driverLicense}</Text>
                        </DocsTd>
                    </DocsTr>
                </DocsTable>
            </DocsListItem>
            <DocsFooter toggleChat={props.toggleChat} popupRef={props.popupRef} toggleSnackBar={props.toggleSnackBar} />
        </DocsList>
    );
};

export default UsaDocsList;
